import { getStreamChatToken } from '@sp/data/bif';
import { ENV_MODE, EnvMode, STREAM_CHAT_API_KEY } from '@sp/data/env';
import { ChatClient, ChatUser, ConnectUserData, SelfPlusExtendedGenerics } from '@sp/util/stream-chat';
import { createEffect, createEvent, forward, merge, restore } from 'effector';
import { StreamChat } from 'stream-chat';
import { streamChatLogger } from './logger';

const client = new StreamChat<SelfPlusExtendedGenerics>(STREAM_CHAT_API_KEY, {
  timeout: 10000,
  logger: streamChatLogger,
});

declare global {
  interface Window {
    streamChat?: ChatClient;
  }
}

if (ENV_MODE !== EnvMode.production) {
  window.streamChat = client;
  console.info('Stream Chat Client API: window.streamChat');
}

const userLoggedIn = createEvent<ConnectUserData>();

const userLoggedOut = createEvent();

const connectUserFx = createEffect((user: ConnectUserData) => client.connectUser(user as ChatUser, getStreamChatToken));

const disconnectUserFx = createEffect(() => client.disconnectUser());

const $isInitialized = restore(merge([connectUserFx.done.map(() => true), disconnectUserFx.map(() => false)]), false);

forward({
  from: userLoggedIn,
  to: connectUserFx,
});

forward({
  from: userLoggedOut,
  to: disconnectUserFx,
});

export const STREAM_CHAT_MODEL = {
  client,
  $isInitialized,
  userLoggedIn,
  userLoggedOut,
} as const;

export type StreamChatModel = typeof STREAM_CHAT_MODEL;
